import { STATUS_BADGES, StatusBadge } from "@/shared/components/StatusBadge";
import { TriggerEvaluationStatus } from "@/shared/domain/actions";

interface TriggerEvaluationStatusChipProps {
  status: TriggerEvaluationStatus;
}

export function TriggerEvaluationStatusChip({
  status,
}: TriggerEvaluationStatusChipProps) {
  return <StatusBadge status={STATUS_BADGES.triggerEvaluation[status]} />;
}
